



































import { defineComponent, ref, PropType } from '@vue/composition-api';
import { ISystemError } from '@/models/error';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { useVModel } from '@vueuse/core';

export default defineComponent({
  name: 'DeleteConfirmationDialog',

  components: {
    ConfirmationDialog
  },

  props: {
    value: { type: Boolean },
    title: { type: String },
    subtitle: { type: String },
    error: {
      type: [Object, Error] as PropType<ISystemError | null>,
      default: () => null,
      required: false
    },
    maxWidth: {
      type: Number,
      default: 550
    }
  },

  setup(props, { emit }) {
    const isDialogActive = useVModel(
      props,
      'value',
      (_prop, value) => {
        emit('input', value);
      },
      { passive: true }
    );

    function clearAllErrors() {
      emit('clearAllErrors');
    }

    function closeDialog() {
      isDialogActive.value = false;
      emit('close');
    }

    return {
      isDialogActive,

      clearAllErrors,
      closeDialog
    };
  }
});
